<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container lg">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">過去事例を見る</span>
        </div>
        <div class="popup-content">

          <FontawesomeIcon v-if="!group1.isListRevisionsLoaded" 
            :icon="['fal','spinner-third']" size="2x" class="icn fa-spin center" />
          <table v-else>
            <colgroup>
              <col style="width:30%;">
              <col style="width:70%;">
            </colgroup>
            <tbody>
              <tr>
                <th></th>
                <td>
                  <div class="column gutter">
                    <div class="column-item col-4 space-gutter">
                      <div class="formparts radio">
                        <input v-model.number="group1.selectedSearchIndexId" type="radio" value="0" id="newest" checked>
                        <label for="newest">最新</label>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>

              <tr v-for="item in group1.packages" :key="'revision_' + item.id">
                <th>{{ item.name }}</th>
                <td>
                  <div class="column gutter">

                    <div v-for="item2 in item.revisions" :key="'revision_item_' + item2.id" class="column-item col-4 space-gutter">
                      <div class="formparts radio">
                        <input v-model.number="group1.selectedSearchIndexId" type="radio" :value="item2.id" :id="'item_' + item.id + '_' + item2.id">
                        <label :for="'item_' + item.id + '_' + item2.id">{{ item2.name }}</label>
                      </div>
                    </div>
                  
                  </div>
                </td>
              </tr>

            </tbody>
          </table>
          <div class="button mt32">
            <button class="btn ga-qa-detail-revision-set" type="submit" name=""
              @click="group1.submit"
            >
              設定
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import * as logicQASelectRevision from '@/logic/qa/QASelectRevision'

export default defineComponent({
  props: {
    startLoading: {
      type: Boolean,
      required: true
    }
  },
  setup (props, context) {

    const group1 = logicQASelectRevision.getGroup(props, context)

    const close = () => {
      context.emit('closeSelectRevision')
    }
   
    return {
      group1,
      close
    }
  }
})
</script>

<style lang="scss" scoped>
.popup-title {
  display: block!important;
  color: $color-hdg;
  font-weight: bold;
}
.popup-content {
  padding-top: 28px!important;
  table {
    width: 100%;
    text-align: left;
    border-collapse: collapse;
    th,td {
      font-size: 1.6rem;
      padding: 16px 0;
    }
    th {
      color: $color-sup;
      vertical-align: text-top;
      font-weight: normal;
    }
  }
  .button {
    .btn {
      width: 230px;
      margin: 0 auto;
    }
  }
}
</style>
